export const EVENTS = {
  buybackCreationWizard: {
    browserNavigationEvent: "browserNavigationEvent",
    addProductToCartAndRestartEvent: "addProductToCartAndRestartEvent",
    goToCartFromWizardEvent: "goToCartFromWizardEvent",
    setNavigationWarningEvent: "setNavigationWarningEvent",
    disableNavigationWarningEvent: "disableNavigationWarningEvent",
  },
};
